import { useAuth } from "../../context/auth-context";
import type {
  AdminBillPaymentTransactionsDataEnvelope,
  AdminBillPaymentTransactionsDataPayload,
} from "./adminTransactionsData";
import { apiQueryKey } from "./queryKeys";
import { useApiQuery } from "./useApiQuery";

const DEFAULT_LIMIT = 25;

/** Query `billSubtypes` (e.g. airtime, data, electricity, betting). Omit or empty for all. */
export type UseAdminBillPaymentTransactionsDataParams = {
  page: number;
  search?: string;
  startDate?: string;
  endDate?: string;
  limit?: number;
  billSubtypes?: string;
  enabled?: boolean;
};

/**
 * Paginated bill payment rows from GET api/admin/transactions/data
 * (?type=billpayment[&billSubtypes=airtime|data|electricity|betting]).
 */
export function useAdminBillPaymentTransactionsDataQuery(
  params: UseAdminBillPaymentTransactionsDataParams
) {
  const { isAuthenticated } = useAuth();
  const {
    page,
    search,
    startDate,
    endDate,
    limit = DEFAULT_LIMIT,
    billSubtypes,
    enabled: enabledParam = true,
  } = params;

  return useApiQuery<
    AdminBillPaymentTransactionsDataEnvelope,
    AdminBillPaymentTransactionsDataPayload
  >({
    queryKey: apiQueryKey("admin-transactions-data", {
      type: "billpayment",
      page,
      limit,
      search: search?.trim() ? search.trim() : null,
      startDate: startDate ?? null,
      endDate: endDate ?? null,
      billSubtypes: billSubtypes?.trim() ? billSubtypes.trim() : null,
    }),
    url: "api/admin/transactions/data",
    params: {
      type: "billpayment",
      page,
      limit,
      search: search?.trim() || undefined,
      startDate,
      endDate,
      billSubtypes: billSubtypes?.trim() || undefined,
    },
    enabled: Boolean(isAuthenticated) && enabledParam,
    select: (body) => body.data,
  });
}
